import './city-nav.css'
import './static/award.svg'
import './static/carrot.svg'
import './static/tickets.svg'
